import React from 'react'

import {Debug} from '~/components/debug'
import {InitDeviceInfo} from '~/components/initDeviceInfo'

export default function App(props) {
  const {children} = props

  return (
    <>
      <Debug />
      <InitDeviceInfo />
      <div>{children}</div>
    </>
  )
}
